import { Injectable, inject } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { ApiClientService } from "~app/common/services/api-client.service";
import { IOrderBasdata, IOrderKundorderSearchResponse, IOrderLeverantorsorderSearchResponse, IOrderProduktionsomradeSearchResponse } from "../models/justeraLeveransplanModel";

@Injectable({
    providedIn: "root"
})
export class JusteraLeveransplanService {
    private readonly apiClient = inject(ApiClientService);

    getJusteraLeveransplanBasdata(): Observable<IOrderBasdata> {
        return this.apiClient.get<IOrderBasdata>("justeraleveransplan/basdata");
    }

    searchForKundTypeAhead(input: string): Observable<ITypeAheadResult[]> {
        const subject = new Subject<ITypeAheadResult[]>();
        if (input.length < 3) {
            return subject.asObservable();
        }
        return this.apiClient.post<any, ITypeAheadResult[]>("typeahead/kund", `"${input}"`, false, null, ApiClientService.JsonHeader);
    }

    searchForMottagningsplatsTypeAhead(input: string, kundordertyp: string): Observable<ITypeAheadResult[]> {
        const subject = new Subject<ITypeAheadResult[]>();
        if (input.length < 3) {
            return subject.asObservable();
        }

        return this.apiClient
            .post<any, ITypeAheadResult[]>("typeahead/mottagningsplats", { input: input,
                kundordertyp: kundordertyp }, false, null, ApiClientService.JsonHeader);
    }

    searchForLeverantorTypeAhead(input: string): Observable<ITypeAheadResult[]> {
        const subject = new Subject<ITypeAheadResult[]>();
        if (input.length < 3) {
            return subject.asObservable();
        }
        return this.apiClient
            .post<any, ITypeAheadResult[]>("Leverantorsorder/SearchForLeverantorByHkInternnrNamnPostortTypeahead", { query: input }, false, null, ApiClientService.JsonHeader);
    }

    searchForAvatalsansvarigTypeahead(input: string): Observable<ITypeAheadResult[]> {
        const subject = new Subject<ITypeAheadResult[]>();
        if (input.length < 3) {
            return subject.asObservable();
        }

        return this.apiClient.post<any, ITypeAheadResult[]>("typeahead/anvandare", { query: input }, false, null, ApiClientService.JsonHeader);
    }

    searchForKundorder(data: any): Observable<IOrderKundorderSearchResponse> {
        return this.apiClient.post("justeraleveransplan/kundorder", data);
    }

    searchForLeverantorsorder(data: any): Observable<IOrderLeverantorsorderSearchResponse> {
        return this.apiClient.post("justeraleveransplan/leverantorsorder", data);
    }

    searchForProduktionsomrade(data: any): Observable<IOrderProduktionsomradeSearchResponse> {
        data.filterOnProduktionsomrade = true; // <-- Kan tas bort när legacy jlp avvecklas
        return this.apiClient.post("justeraleveransplan/produktionsomrade", data);
    }
}
